import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";

//models
import IFermetureModule from '../../models/IFermetureModule';
import Guid from "../../models/Guid";

import Form, {GroupItem, Label, SimpleItem, ButtonItem, FormRef} from "devextreme-react/form";
import {Button, DateBox, NumberBox, TextBox} from "devextreme-react";
import {Item as TabItem} from "devextreme-react/tab-panel";
import {useContextPopupPage} from "../../components/popups/PopupPage";
import FormListBaseTab from '../base/form-list-base-tab';
import useCustomDataSource, {Mode} from '../../hooks/useCustomDataSource';
import {FormListBase} from '../base';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionFolios from '../gestion-folios/gestion-folios';

interface IPopupGenererEcrituresOuvertureProps {
    isPopupOpen: boolean,
    onClose: () => void
    // onReserver: (ajoutReservationOption: IAjoutReservationOption) => void
}

function PopupGenererEcrituresOuverture({isPopupOpen, onClose}: IPopupGenererEcrituresOuvertureProps) {
    // const { getData: getTrancheAges } = useApi<ITrancheAge[]>("trancheAge");
    const fermetureModuleFormDataSource = useCustomDataSource<IFermetureModule, IFermetureModule>({path: "fermeturemodule", primaryKey: "idFermetureModule"});
    const {setMainForm, selectedDataRow: selectedJournal, mode, setSelectedDataRow, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged} = fermetureModuleFormDataSource;
    const [isOpen, setPopupIsOpen] = useState(true);
    const {editorOptions: folioEditorOption, PopupGestion: PopupGestionFolios} = useLookUpBase({isModeModifier: mode !== Mode.Lecture, controllerName: "folio", setDataRow: () => setDataRow("idFolio"), showClear: mode !== Mode.Lecture});
    const {selectedValue, setSelectedValue} = useContextPopupPage();
    const formRef = useRef<FormRef>(null);

    const setDataRow = (e: string) => {
        setSelectedDataRow((prev: IFermetureModule) => (
            {...prev, [e]: Guid.empty.toString()}
        ));
        setIsFieldModifier(true);
    }

    const onSelectionchanged = (item: any, e: string) => {
        setIsFieldModifier(true);
        setSelectedDataRow((prev: IFermetureModule) => {
            return {...prev, [e]: item.id}
        })
    }

    const closeButtonOption = useMemo(() => {
        return {
            text: "Annuler",
            onClick: () => setPopupIsOpen(false)
        }
    }, [onClose])
    const reserverButtonOption = useMemo(() => {
        return {
            text: "OK",
            onClick: () => {
                onClose()
            }
        }
    }, [onClose])

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (setSelectedValue && selectedJournal?.idFermetureModule) {
            setSelectedValue(selectedJournal?.idFermetureModule)
        }
    }, [selectedJournal]);

    if (!isOpen) return null;
    return (
        <Popup title={"Générer une écriture d'ouverture"} dragEnabled={false} visible={isOpen} onHiding={onClose} width={400}
               height={325}
        >
            <Position
                my="center"
                collision="fit"
            />
            <FormListBase key={"frm-messages"} data={fermetureModuleFormDataSource} hideList={true} hideToolbar={true}>
                <FormListBaseTab className='no-nav-button'>
                    <TabItem>
                        <Form
                            ref={formRef}
                            readOnly={false} alignItemLabelsInAllGroups={true}
                            formData={selectedJournal || {} as IFermetureModule}
                            className={"forms"} labelLocation={"left"} showColonAfterLabel={true}
                            onFieldDataChanged={onFieldDataChanged}
                        >
                            <PopupGestionFolios onSelectionchanged={(i) => onSelectionchanged(i, 'idfolio')}>
                                <GestionFolios isModeSelection={true}/>
                            </PopupGestionFolios>
                            <GroupItem>
                                <SimpleItem key={"frm-annee"} dataField={""} editorType={"dxSelectBox"}>
                                    <Label text={"Année à reporter"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-folio"} dataField={"idFolio"}
                                            editorType={"dxSelectBox"}
                                            editorOptions={folioEditorOption}
                                >
                                    <Label text={"Folio bénéfices non répartis"}/>
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                    </TabItem>
                </FormListBaseTab>
            </FormListBase>
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="before"
                options={reserverButtonOption}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={closeButtonOption}
            />
        </Popup>
    )
        ;
}

export default PopupGenererEcrituresOuverture;